/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2026-01-09 16:16:05
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2026-04-01 10:00:00
 */
import { useState, useCallback, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { fetchTrialCount } from '../../../../actions/photo'

// 多级下载试用的最大次数
const MAX_MULTI_TRIAL = 10

interface UseTrialOptions {
  autoFetch?: boolean
  visible?: boolean
}

interface TrialData {
  multiLeft: number
  renameLeft?: number
  renameLimit?: number
}

export function useTrial(options: UseTrialOptions = {}) {
  const { autoFetch = false, visible = false } = options
  const dispatch = useAppDispatch()
  const groupID = useAppSelector((state) => state.group.groupId)

  const [multiLeft, setMultiLeft] = useState<number>(MAX_MULTI_TRIAL)
  // renameLeft: undefined 表示无限制（存量会员 / limit=-1），数字表示剩余次数
  const [renameLeft, setRenameLeft] = useState<number | undefined>(undefined)
  // renameLimit: 服务端返回的试用上限，-1无限制, 0不可用, 5限5次
  const [renameLimit, setRenameLimit] = useState<number | undefined>(undefined)
  const [loading, setLoading] = useState(false)

  const fetchTrialData = useCallback(async (): Promise<TrialData | null> => {
    if (!groupID) return null

    setLoading(true)
    try {
      const res = await dispatch(fetchTrialCount({ groupID }))
      const trialData = res && res.data ? res.data : {}
      const usedMulti = trialData.multiLevelFolderTrialCount || 0
      const multi = Math.max(0, MAX_MULTI_TRIAL - usedMulti)
      setMultiLeft(multi)

      // 解析高级重命名试用限制
      const limit: number | undefined = trialData.photoRenameTrialLimit
      const usedRename = trialData.photoRenameTrialCount || 0
      setRenameLimit(limit)

      let rename: number | undefined
      if (typeof limit === 'undefined' || limit === -1) {
        // 无限制（存量会员或未返回该字段）
        rename = undefined
        setRenameLeft(undefined)
      } else if (limit === 0) {
        // 不可用
        rename = 0
        setRenameLeft(0)
      } else {
        // 有限制（如 5 次）
        rename = Math.max(0, limit - usedRename)
        setRenameLeft(rename)
      }

      setLoading(false)
      return { multiLeft: multi, renameLeft: rename, renameLimit: limit }
    } catch (err) {
      console.warn('error:', err)
      setLoading(false)
      return null
    }
  }, [dispatch, groupID])

  // 自动获取模式
  useEffect(() => {
    if (autoFetch && visible && groupID) {
      fetchTrialData()
    }
  }, [autoFetch, visible, groupID, fetchTrialData])

  // 手动获取函数
  const refresh = useCallback(async (): Promise<TrialData | null> => {
    return fetchTrialData()
  }, [fetchTrialData])

  return {
    multiLeft,
    renameLeft,
    renameLimit,
    loading,
    refresh
  }
}
